<template>
  <div id="app">
  <v-app id="inspire">
    <v-content>
      <v-container fluid half-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Login</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field prepend-icon="person" v-model="login.username" ref="uid"
                  name="userid" label="UserId" id="userid" type="text" required="true" autofocus>
                  </v-text-field>
                  <v-text-field prepend-icon="lock" v-model="login.password"
                  name="password" label="Password" id="password" type="password" required="true">
                  </v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn round color="primary" dark @click="auth">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</div>
</template>


<script>
export default {
  name: "Login",
  data() {
    return {
      loading: false,
      //users:[],
      login: {
        username: "",
        password: ""
      }
    };
  },
  created () {
    this.initialize();
  },
  methods: {
    initialize(){
      if(this.$store.state.users.length < 1){
        this.$store.commit('initUsers');
      }
    },
    auth() {
      this.loading = true;
      this.initialize();
      this.$store.state.users.forEach(item=>{
        if(item.id === this.login.username ){
          if(item.password == this.login.password && item.valid ===0){
            let inf = {
              login:true,
              userid:item.id,
              password:item.password,
              valid:item.valid,
            };
            this.$store.dispatch('setLogin', inf);
            this.loading = false;
            this.$router.push({ name: 'list' });
            return;
          }
        }
      });
      this.$nextTick(() => this.$refs.uid.focus());
      this.loading = false;
      /*
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      */
    }
  }
};
</script>
